import { atom } from "recoil"

// Lives here (not in DesignerDebugPanel) so panel validation state can read
// the toggle without importing the Studio component tree, which would create
// a circular import back into the elements barrel.
export const enablePanelOverlapValidationState = atom<boolean>({
  key: `enablePanelOverlapValidation`,
  default: true,
})
